<template>
  <div>
    <nav class="border-b border-gray-300 px-2 md:px-0 py-2">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'organization_details', params: { orgId: orgId }}">
              organization
            </router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'venues'}">venues</router-link>
            <span class="mx-2">/</span>
            <span>venue</span>
            <span class="mx-2">/</span>
            <span>Access points</span>
          </div>
          <div class="text-xl">
            {{ accessPoint.name }} profile
          </div>
        </div>
        <div class="">
          <div class="inline-block relative float-right">
            <button style="color: white !important;" @click="deleteHotspot" v-if="$store.getters.can('delete_ap')"
                    class="bg-red-500 text-white hover:bg-red-700 py-2 px-4 rounded-sm inline-flex items-center">
              <feather type="trash" size="16" class="mr-2"></feather>
              Delete
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div class="py-4 md:px-0 px-2">
      <div class="md:flex block">
        <div class="w-full rounded-lg  overflow-hidden  md:max-w-xs mb-3">
          <div class=" bg-white rounded-lg border shadow-sm">
            <img src="https://www.iplocation.net/assets/images/blog/featured/hotspot-vs-tethering.jpg"
                 class="w-full hidden md:block"/>
            <div class="text-center px-3 pb-6 pt-2">
              <h3 class="text-black text-sm bold font-sans">{{ accessPoint.name || '' }}</h3>
              <p class="mt-2 font-sans font-light text-grey-dark">MAC address:
                {{ accessPoint.mac_address || 'Not available' }}</p>
            </div>

            <ul class="mt-2 flex flex-wrap md:block">
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'access_point', params: {apId: apId, path:'overview'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="eye" size="16" class="mr-4"></feather>
                  Overview
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'access_point', params: {apId: apId, path:'connections'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="activity" size="16" class="mr-4"></feather>
                  Connections
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'access_point', params: {apId: apId, path: 'devices'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="airplay" size="16" class="mr-4"></feather>
                  Devices
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'access_point', params: {apId: apId, path:'customers'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="users" size="16" class="mr-4"></feather>
                  Clients
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
                <router-link :to="{name:'access_point', params: {apId: apId, path:'settings'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="sliders" size="16" class="mr-4"></feather>
                  Settings
                </router-link>
              </li>
              <li class="border-l-4 border-transparent  hover:border-teal-700 my-2 ">
                <div @click="deleteHotspot" v-if="$store.getters.can('delete_ap')"
                     class="block items-center flex lg:mt-0 px-3 h-8 text-red-500 hover:text-teal-700">
                  <feather type="trash" size="16" class="mr-4"></feather>
                  Delete
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="w-full mt-3 md:mt-0 md:mx-4 ">

          <Connections
              :filters="filters"
              :access-points="[accessPoint.mac_address]"
              :breadcrumb="false"
              v-if="path === 'connections'"/>
          <Devices
              :filters="filters"
              :access-points="[accessPoint.mac_address]"
              :breadcrumb="false"
              v-else-if="path === 'devices'"/>

          <Customers
              :filters="filters"
              :access-points="[accessPoint.mac_address]"
              :breadcrumb="false"
              v-else-if="path === 'customers'"/>

          <UpdateOrCreateAccessPointComponent title="Update access point" :venue-id="accessPoint.venue_id"
                                              :access-point-id="apId" v-else-if="path === 'settings'"/>
          <div v-else>
            <!--              Overview numbers-->
            <div class="grid gap-4 grid-cols-4 justify-between">
              <div class="flex bg-teal-500 text-white shadow-sm rounded">
                <div class="p-4 py-5">
                  <div class="font-bold text-xl">{{ accessPoint.devicesCount || 0 }}</div>
                  Devices
                </div>
              </div>
              <div class="flex bg-white shadow-sm  rounded">
                <div class="p-4 py-5">
                  <div class="font-bold text-xl">{{ accessPoint.customersCount || 0 }}</div>
                  Unique Clients
                </div>
              </div>
              <div class="flex bg-green-700 text-white  shadow-sm  rounded">
                <div class="p-4 py-5">
                  <div class="font-bold text-xl">{{ accessPoint.connectionsCount || 0 }}</div>
                  Total Connections
                </div>
              </div>
              <div class="flex bg-red-700 text-white shadow-sm  rounded">
                <div class="p-4 py-5">
                  <div class="font-bold text-xl">{{ accessPoint.onlineConnectionsCount || 0 }}</div>
                  Online
                </div>
              </div>
            </div>
            <!--              End overview numbers-->

            <!--              connections graph-->
            <div class="block md:flex mt-4">
              <div class="w-full md:pr-2 md:w-1/2">
                <!--                <DwellTime :filters="filters"/>-->
              </div>
              <div class="w-full md:pl-2 md:w-1/2">
                <!--                <ConnectionsGraph :filters="filters"/>-->
              </div>
            </div>
            <!--              connections graph-->
            <div class="block md:flex mt-4">
              <!--              <Heatmap class="w-full md:pr-2 md:w-1/2"/>-->
              <!--              <connections class="w-full md:pl-2 md:w-1/2" :online="true" :breadcrumb="false" :filters="filters"/>-->
            </div>
            <!--              End connections graph-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UpdateOrCreateAccessPointComponent from "../../components/UpdateOrCreateAccessPointComponent";
import GraphQl from "@/services/graphql.service";
import Connections from "@/modules/connections/Connections";
import Devices from "@/modules/devices/Devices";
import moment from "moment";
import Customers from "@/modules/customers/Customers";

export default {
  name: "AccessPointDetails",
  components: {Customers, Devices, Connections,  UpdateOrCreateAccessPointComponent},
  props: {
    apId: String,
    path: String
  },
  data() {
    return {
      accessPoint: Object,
      orgId: this.$store.getters.orgId,
      filters: {
        dateRange: {
          startDate: moment().subtract(1, 'year').format("YYYY-MM-DD HH:MM"),
          endDate: moment(moment.now()).format("YYYY-MM-DD HH:MM")
        },
        venues: [{name: '', id: this.venueId}],
      },
    }
  },
  mounted() {
    this.getHotspot();
  },
  methods: {
    getHotspot() {
      GraphQl.sendRequest('{accessPoint(id:"' + this.apId + '") {id venue_id name mac_address serial_number connectionsCount devicesCount onlineConnectionsCount customersCount}}')
          .then(response => {
            this.accessPoint = response.accessPoint;
          }).finally(() => {
        this.loading = false;
      })
    },
    deleteHotspot() {
      const deleteConfirm = confirm("Are you sure you want to delete this access point?");
      if (deleteConfirm)
        this.axios.delete(process.env.VUE_APP_SERVER_URL + `/api/v1/access_points/${this.apId}`)
            .then((response) => {
              this.$root.$emit('alert_success', [response.data.data.message]);
              this.$router.push({
                message: 'venue_details',
                params: {venueId: this.accessPoint.venue_id, path: 'access_points'}
              })
            });
    }
  }
}
</script>
<style scoped>
</style>